import { FormHelperText, FormHelperTextProps } from '@mui/material'
import { FC } from 'react'

const FormHelperTextWrapper: FC<FormHelperTextProps> = ({ ...props }) => (
  <FormHelperText {...props} />
)

export default FormHelperTextWrapper
